import type { FC } from 'react';
import { useAppSelector } from '../../redux/hooks';
import { selectedUnit } from '../../redux/reducers/unitSlice';

interface Props {
  // Centered variant (used once every Target skill is complete): the title is centered and free to wrap
  // onto a second line. The default (inline) variant shares its row with the badges, so it truncates.
  centered?: boolean;
}

// The unit header's "Unit <name>: <summary>" heading. Reads the selected unit from redux, like
// UnitSkillBadge, so both header layouts can drop it in without prop-drilling.
export const UnitHeaderTitle: FC<Props> = ({ centered = false }) => {
  const unit = useAppSelector(selectedUnit);

  return (
    <div
      className={`tw-flex tw-items-baseline tw-gap-2 ${
        centered ? 'tw-flex-wrap tw-justify-center tw-text-center' : 'tw-min-w-0'
      }`}
    >
      {unit?.name && (
        <span className="tw-shrink-0 tw-text-sm tw-font-bold tw-uppercase tw-tracking-wide tw-text-neutral-800 tw-font-['Atkinson_Hyperlegible']">
          Unit {unit.name}:
        </span>
      )}
      <h1
        className={`tw-text-xl tw-font-bold tw-text-neutral-950 tw-font-['Atkinson_Hyperlegible'] ${
          centered ? '' : 'tw-truncate'
        }`}
      >
        {unit?.summary}
      </h1>
    </div>
  );
};
